<form [formGroup]="form" class="alarm-type-selection-form">
  <osp-card-option-list
    [options]="contractAndServiceOptions"
    [title]="contractAndService.title"
    [formControlName]="controlNames.CONTRACT_AND_SERVICE"
  />
  <osp-card-option-list
    [options]="operationalStatusOptions"
    [title]="operationalStatus.title"
    [formControlName]="controlNames.OPERATIONAL_STATUS"
  />
  <osp-card-option-list
    [options]="costsAndConditionOptions"
    [title]="costsAndCondition.title"
    [formControlName]="controlNames.COSTS_AND_CONDITION"
  />
</form>
